import React from "react";

const Loader = ({ message = "Loading..." }) => {
  return (
    <div className="flex flex-col items-center justify-center min-h-[250px] space-y-6">
      
      {/* Rotating gradient ring */}
      <div className="relative w-20 h-20">
        <div className="absolute inset-0 rounded-full border-4 border-t-indigo-500 border-r-purple-500 border-b-pink-500 border-l-transparent animate-spin"></div>

        {/* Center bouncing dots */}
        <div className="absolute inset-0 flex items-center justify-center">
          {[...Array(3)].map((_, i) => (
            <span
              key={i}
              className="w-3 h-3 bg-indigo-500 rounded-full animate-bounce mx-1"
              style={{ animationDelay: `${i * 0.2}s` }}
            />
          ))}
        </div>
      </div>

      {/* Loading text */}
      <p className="text-gray-600 font-semibold text-base md:text-lg animate-pulse">
        {message}
      </p>
    </div>
  );
};

export default Loader;
